import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {index > 0 && (
            <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
              <i className="ri-arrow-right-s-line"></i>
            </span>
          )}
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-700 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}